import { Image } from "./image";
import React from "react";

export const Gallery = (props) => {
  const expandLabel =
    props.ui && props.ui.gallery ? props.ui.gallery.expand : "Expand";

  return (
    <div id="portfolio" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>{props.ui && props.ui.gallery ? props.ui.gallery.title : "Gallery"}</h2>
        </div>
        <div className="row">
          <div className="portfolio-items">
            {props.data
              ? props.data.map((d, i) => (
                  <div
                    key={`${d.largeImage}-${i}`}
                    className="col-sm-6 col-md-4 col-lg-4"
                  >
                    <Image
                      label={expandLabel}
                      largeImage={d.largeImage}
                      smallImage={d.smallImage}
                    />
                  </div>
                ))
              : "Loading..."}
          </div>
        </div>
      </div>
    </div>
  );
};
